import { connect } from 'react-redux';
import branch from 'recompose/branch';
import compose from 'recompose/compose';
import renderComponent from 'recompose/renderComponent';
import withState from 'recompose/withState';
import {
  shouldOpenClockOutModal,
} from '../selectors';
import SignOut from '../../../auth/signout/signOut';
import ClockOutContainer from './ClockOutContainer';

const mapStateToProps = state => ({
  openModal: shouldOpenClockOutModal(state),
});

const enhance = compose(
  connect(mapStateToProps),
  withState('skipClockOut', 'setSkipClockOut', false),
  branch(
    props => props.openModal && !props.skipClockOut,
    renderComponent(ClockOutContainer),
  )
);

export default enhance(SignOut);
